import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var TreesOutlineSVG = function TreesOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29 28h-6v-8.09A5.99 5.99 0 0025.58 9.2a4.5 4.5 0 10-7.16 0A5.99 5.99 0 0021 19.9V28H10v-3.6a5.5 5.5 0 002.12-9.93 4 4 0 10-6.24 0A5.5 5.5 0 008 24.4V28H3a1 1 0 000 2h26a1 1 0 000-2zM18 14a3.97 3.97 0 011.61-3.2 2 2 0 00.4-2.8A2.5 2.5 0 1124 8a2 2 0 00.4 2.8A3.98 3.98 0 0123 17.86V13a1 1 0 00-2 0v4.86A4 4 0 0118 14zM5.5 19a3.5 3.5 0 011.52-2.88 2 2 0 00.43-2.89A1.98 1.98 0 017 12a2 2 0 014 0 1.98 1.98 0 01-.45 1.23 2 2 0 00.43 2.89 3.48 3.48 0 01-.98 6.22v-4.38a.96.96 0 00-.96-.96h-.08a.96.96 0 00-.96.96v4.38A3.5 3.5 0 015.5 19z"
  }));
};
TreesOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TreesOutlineSVG);